module.exports = __webpack_public_path__ + "img/oufu_103_6x128x12.prt.0a1f0a40.jpg";